'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Organzations = function (_Resource) {
    (0, _inherits3.default)(Organzations, _Resource);

    function Organzations() {
        (0, _classCallCheck3.default)(this, Organzations);
        return (0, _possibleConstructorReturn3.default)(this, (Organzations.__proto__ || (0, _getPrototypeOf2.default)(Organzations)).apply(this, arguments));
    }

    (0, _createClass3.default)(Organzations, [{
        key: 'delete',

        /**
         * @api {delete} /v1/organizations/:organization_id delete
         * @apiGroup Organizations
         * @apiName delete
         * @apiDescription Delete organization.
         * @apiParam {Number} organization_id
         * @apiExample {js} Example:
         *             gigwalk.organizations.delete({...})
         */
        value: function _delete(params) {
            return this.client.delete('/v1/organizations/' + params.organization_id);
        }

        /**
         * @api {get} /v1/organizations/:organization_id get
         * @apiGroup Organizations
         * @apiName get
         * @apiDescription Get organization.
         * @apiParam {Number} organization_id
         * @apiExample {js} Example:
         *             gigwalk.organizations.get({...})
         */

    }, {
        key: 'get',
        value: function get(params) {
            return this.client.get('/v1/organizations/' + params.organization_id);
        }

        /**
         * @api {put} /v1/organizations/:organization_id update
         * @apiGroup Organizations
         * @apiName update
         * @apiDescription Update organization information. The endpoint can also be used to update the company logo. A file with
                           name 'logo' has to be added in a multipart form in order to do that. For example, the following curl:
                           - curl -X PUT http://stage-api.apps.gigwalk.com/v1/organizations/7 -F logo=@path/to/file.png --user user:password
         * @apiParam {Number} organization_id
         * @apiParam {Object} organization
         * @apiExample {js} Example:
         *             gigwalk.organizations.update({...})
         */

    }, {
        key: 'update',
        value: function update(params) {
            return this.client.put('/v1/organizations/' + params.organization_id, (0, _extends3.default)({}, params.organization));
        }

        /**
         * @api {get} /v1/organizations getAll
         * @apiGroup Organizations
         * @apiName getAll
         * @apiDescription Get all organizations. Capable of returning paginated results.
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.organizations.getAll({...})
         */

    }, {
        key: 'getAll',
        value: function getAll(params) {
            var query = params ? this.stringForQueryObject(params.query) : '';

            return this.client.get('/v1/organizations' + query);
        }

        /**
         * @api {post} /v1/organizations create
         * @apiGroup Organizations
         * @apiName create
         * @apiDescription Crete organization. Only super-admins and above can create or update organization information.
         * @apiParam {Object} organization
         * @apiExample {js} Example:
         *             gigwalk.organizations.create({...})
         */

    }, {
        key: 'create',
        value: function create(params) {
            return this.client.post('/v1/organizations', (0, _extends3.default)({}, params.organization));
        }
    }]);
    return Organzations;
}(_resource2.default);

exports.default = Organzations;
//# sourceMappingURL=index.js.map